import { useEffect, useState, useContext } from "react";

import { isSessionValid, getCurrentUser, signOut as logOut } from "pages/Auth/Cogcognito";
import { convertCognitoAttr } from "utils/util-functions";
import { GlobalContext } from "context/GlobalContext";
import { useNavigate } from "react-router";
import { reportError } from "utils/diagnostics";

const useProvideAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(isSessionValid());
  const [userData, setUserData] = useState({});
  const [isAuthLoaded, setIsAuthLoaded] = useState(false);
  const navigate = useNavigate();

  const updateInfo = async () => {
    const isAuth = isSessionValid();
    setIsAuthenticated(isAuth);

    if (!isAuth) throw new Error("User is not authenticated!");
    const user = await getCurrentUser();
    if (!user) throw new Error("Invalid User!");
    const userAttr = convertCognitoAttr(user);
    setUserData(userAttr);
    return userAttr;
  };

  const signOut = async () => {
    await logOut?.();
    navigate("/login");
    setIsAuthenticated(false);
  };

  useEffect(() => {
    if (isSessionValid()) {
      updateInfo()
        .catch((error) => {
          reportError("auth.load_profile", error);
          setIsAuthenticated(false);
        })
        .finally(() => setIsAuthLoaded(true));
    } else {
      setIsAuthLoaded(true);
    }
  }, []);

  return {
    isAuthenticated,
    signOut,
    refetch: updateInfo,
    isAuthLoaded,
    ...userData,
  };
};

const useAuth = () => {
  const { auth } = useContext(GlobalContext);
  return auth;
};

export { useProvideAuth, useAuth };
